import React, { useEffect } from 'react';

import Button from 'react-bootstrap/Button'

import MailIcon from './../../../../../assets/img/mail.svg'

import './index.css'

export default function ConfirmMail() {

    useEffect(() => {
        console.log('confirm mail component')
    }, [])


    return (
        <div className="ConfirmMail">
            <img src={MailIcon} alt="Mail confirm" />
            <h1>Otimo! Você se cadastrou com sucesso no Ares!</h1>

            <p>
                Enviamos um email de confirmação para o email <b>michael.dsa41@gmail.com</b> <br />
                Por favor cheque a sua caixa de email e confirme o seu cadastro para continuar!
            </p>

            <Button variant="primary" type="button">
                Reenviar email
            </Button>
        </div>
    )

}